/**
 * Values offered by the Contacts quick filters for the OPQRY Enum fields, with the label keys the list columns
 * already use. OPQRY's metadata carries no enum values: a member added to OPHUB's `ContactStatus` or `Gender`
 * shows here only once it is added below. `Deleted` is internal and never offered.
 */
export const CONTACT_FILTER_VALUES = {
    status: [
        { id: "Active", labelKey: "contact.detail.status.active" },
        { id: "Inactive", labelKey: "contact.detail.status.inactive" },
        { id: "Suspended", labelKey: "contact.detail.status.suspended" },
        { id: "Deceased", labelKey: "contact.detail.status.deceased" },
    ],
    gender: [
        { id: "Male", labelKey: "contact.detail.options.gender.male" },
        { id: "Female", labelKey: "contact.detail.options.gender.female" },
        { id: "NonBinary", labelKey: "contact.detail.options.gender.nonBinary" },
        { id: "Other", labelKey: "contact.detail.options.gender.other" },
        { id: "PreferNotToSay", labelKey: "contact.detail.options.gender.preferNotToSay" },
    ],
};
/** Contact paths holding a calendar date (OPHUB `DateOnly`): see `useQuickFilters` for why they are listed. */
export const CONTACT_DATE_ONLY_FIELDS = new Set(["birthDate"]);
